import { PERMISSIONS } from '@/shared/constants/permissions';
import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetRolePermissionMatrixRequestDtoSchema = z.object();

const GetRolePermissionMatrixResponseDtoSchema = z.object({
  roles: z.array(
    z.object({
      roleId: z.number(),
      name: z.string(),
      systemRole: z
        .enum([
          'SUPER_ADMIN',
          'ADMIN',
          'REGIONAL_MANAGER',
          'FACILITY_MANAGER',
          'CONTRACTOR',
        ])
        .nullable(),
      permissions: z.array(z.enum(PERMISSIONS)),
    })
  ),
});

export type GetRolePermissionMatrixRequestDto = z.infer<
  typeof _GetRolePermissionMatrixRequestDtoSchema
>;
export type GetRolePermissionMatrixResponseDto = z.infer<
  typeof GetRolePermissionMatrixResponseDtoSchema
>;

export const getRolePermissionMatrix = (
  config?: AxiosRequestConfig<GetRolePermissionMatrixRequestDto>
) => {
  return api
    .get('/roles/permissions-matrix', config)
    .then(responseContract(GetRolePermissionMatrixResponseDtoSchema));
};
